import React from "react";

export interface NotificationBellProps {
  onClick: () => void;
  newNotifications: number;
  hasUnread?: boolean;
}

const NotificationBell = ({
  onClick,
  newNotifications,
  hasUnread,
}: NotificationBellProps) => {
  return (
    <button
      onClick={onClick}
      className="relative flex items-center justify-center w-[28px] h-[28px] md:w-[35px] md:h-[35px] bg-blue-500 rounded-full shadow-md border-none transition duration-300 hover:bg-blue-600 active:scale-90 focus:outline-none group"
      aria-label="Show notifications"
      type="button"
    >
      <svg
        viewBox="0 0 448 512"
        className="bell w-[15px] md:w-[18px] h-[15px] md:h-[18px] transition-transform duration-300 group-hover:animate-bellRing"
      >
        <path
          d="M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
          fill="white"
        />
      </svg>
      {hasUnread && newNotifications === 0 && (
        <span className="absolute top-1 right-1 w-2 h-2 bg-blue-500 rounded-full border-2 border-white"></span>
      )}
      {newNotifications > 0 && (
        <span className="absolute top-1 md:top-2 right-0 inline-flex items-center justify-center px-1 md:px-2 py-1 text-[7px] md:text-xs font-bold leading-none text-red-100 -translate-y-1/2 translate-x-1/2 bg-red-600 rounded-full">
          {newNotifications}
        </span>
      )}
      <style>{`
        @keyframes bellRing {
          0%, 100% { transform-origin: top; }
          15% { transform: rotateZ(10deg); }
          30% { transform: rotateZ(-10deg); }
          45% { transform: rotateZ(5deg); }
          60% { transform: rotateZ(-5deg); }
          75% { transform: rotateZ(2deg); }
        }
        .group:hover .bell {
          animation: bellRing 0.9s both;
        }
      `}</style>
    </button>
  );
};

export default NotificationBell;
